<template>
  <div class="form-wrapper">
    <div class="form-container">
      <form @submit.prevent="handleForgotPassword">
        <h2 style="text-align: center; margin-bottom: 1.5rem;">Recuperar Contraseña</h2>
        
        <div class="form-group" style="margin-bottom: 1.5rem;">
          <label for="email" style="font-weight: 600; font-size: 13.5px; margin-bottom: 0.4rem; display: block;">Email</label>
          <input
            id="email"
            v-model="email"
            type="email"
            placeholder="Ingrese su email registrado"
            required
          />
        </div>

        <button class="main_button-green" type="submit" :disabled="loading" style="width: 100%; padding: 12px; margin-bottom: 1rem;">
          {{ loading ? "Cargando..." : "Recuperar Contraseña" }}
        </button>

        <p style="text-align: center; margin-bottom: 0; font-size: 13.5px;">
          <router-link to="/" style="color: var(--clear-gray) !important;">Volver a iniciar sesión</router-link>
        </p>
      </form>
    </div>

    <img :src="logo" alt="Logo Click and Plan" class="logo" style="width: 100%; max-width: 320px; margin-top: 2.5rem;" />
    <ErrorPopup :errorMessage="error" />
  </div>
</template>

<script setup>
  import { ref } from "vue";
  import { useLoadingStore } from "@/stores/loadingStore";

  import ErrorPopup from "@/components/common/ErrorPopup.vue";

  const error = ref(null);
  const email = ref("");
  const logo = require("@/assets/images/logo.png"); // Ruta de la imagen
  const loadingStore = useLoadingStore(); // Obtener acceso al store

  const handleForgotPassword = async () => {
    loadingStore.setLoading(true);
    error.value = null;

    try {
      const response = await fetch(process.env.VUE_APP_API_URL+"api/dashboard/auth/forgot_password", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "vdas": process.env.VUE_APP_API_VDAS,
          "cp-token": process.env.VUE_APP_API_CP_TOKEN,
        },
        body: JSON.stringify({
          "email": email.value,
        }),
      });

      if (!response.ok) {
        error.value = "Error en la autenticación";
      }

      const data = await response.json();

      error.value = data.message;

    } catch (_) {
      error.value = "Error en la comunicación, por favor, vuelve a intentarlo";
    } finally {
      loadingStore.setLoading(false);
    }
  };
</script>

<style scoped>

.logo {
  width: 100%;
  max-width: 450px;
  margin-top: 100px;
  padding-bottom: 10px;
}

.form-group {
  margin-bottom: 15px;
}

label {
  display: block;
  margin-bottom: 5px;
}

input {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
}
</style>